<template>
	<div class="h-screen w-full bg-[#B9BECB] ">
		<router-view></router-view>
	</div>
</template>

<script>
	export default {
		data() {
			return {

			}
		},

		mounted() {

		},
		methods: {

		}
	}
</script>

<style>
</style>